import ApiService from './api.service.js';

export default {
  getClientCatalogueData(clientId) {
    return ApiService.get(`/courses/catalogues/clients/${clientId}?lean=true`);
  },
  updateCatalogue(catalogueId, data) {
    return ApiService.put(`/courses/catalogues/${catalogueId}`, JSON.stringify(data));
  }
};
